import PropTypes from 'prop-types';

const Expenses = ({ color }) => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.51599 7.29167V3.125C4.51599 2.46196 4.77938 1.82607 5.24822 1.35723C5.71706 0.888392 6.35295 0.625 7.01599 0.625C7.67903 0.625 8.31492 0.888392 8.78376 1.35723C9.2526 1.82607 9.51599 2.46196 9.51599 3.125V7.29167M2.29187 4.79167H11.741C11.9813 4.79164 12.2188 4.84357 12.4372 4.94392C12.6555 5.04426 12.8496 5.19063 13.0061 5.373C13.1626 5.55537 13.2778 5.76943 13.3438 6.00049C13.4098 6.23155 13.4251 6.47415 13.3885 6.71167L12.3427 13.505C12.2519 14.0954 11.9527 14.6337 11.4994 15.0226C11.046 15.4115 10.4683 15.6252 9.87103 15.625H4.16103C3.56387 15.625 2.98643 15.4112 2.53322 15.0223C2.08001 14.6335 1.78097 14.0952 1.6902 13.505L0.644366 6.71167C0.607839 6.47415 0.623106 6.23155 0.68912 6.00049C0.755134 5.76943 0.870333 5.55537 1.02682 5.373C1.18331 5.19063 1.37738 5.04426 1.59573 4.94392C1.81409 4.84357 2.05156 4.79164 2.29187 4.79167Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Expenses.propTypes = {
  color: PropTypes.string,
};

Expenses.defaultProps = {
  color: '#696F7C',
};

export default Expenses;
